module.exports = __webpack_public_path__ + "files/b39e486c59c610c47276d7c56ea5e69f.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/patch.png
// module id = 530
// module chunks = 27